import { CarService } from "../../../service/car-service";

const sendReferralMessage = (payload) => () => {
    return new Promise((resolve, reject) => {
        CarService.sendReferralMessage(payload)
            .then(response => resolve(response.data.detail))
            .catch(error => reject(error));
    });
};

export {
    sendReferralMessage
};
